import PropTypes from 'prop-types';
import React from 'react';
import 'react-virtualized/styles.css';
import { Iterable } from 'immutable';
import { AutoSizer } from 'react-virtualized';
import CardDeck from '../../components/CardDeck.react';
import SavedJobCard from './components/SavedJobCard.react';

const SavedJobDeck = ({ savedJobs, selectedSavedJobId }, { router }) => {
  const onSelect = (savedJob) => {
    if (savedJob.id) {
      router.push(`/savedjobs/${savedJob.id}`);
    }
  };

  const onDeadSpaceClick = () => {
    router.push('/savedjobs');
  };

  return (
    <AutoSizer>
      {({ height, width }) => (
        <div style={{ height, width }}>
          <CardDeck
            className='saved-job-deck'
            height={height}
            width={width}
            onDeadSpaceClick={onDeadSpaceClick}
            scrollable
          >
            {savedJobs.map(savedJob => (
              <SavedJobCard
                savedJob={savedJob}
                onClick={onSelect}
                key={savedJob.id}
                maxPerRow={selectedSavedJobId ? 2 : 3}
                selected={selectedSavedJobId ? selectedSavedJobId === savedJob.id : false}
              />
            ))}
          </CardDeck>
        </div>
      )}
    </AutoSizer>
  );
};

export default SavedJobDeck;

SavedJobDeck.propTypes = {
  savedJobs: PropTypes.instanceOf(Iterable),
  selectedSavedJobId: PropTypes.number,
};

SavedJobDeck.contextTypes = {
  router: PropTypes.object,
};
